<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <center v-if="!status">
      <div   style="    position: absolute;
      right: 28vw;
      width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5 p-4">
        <div class="card bg-white p-3 mb-3 d-flex align-items-center justify-content-between flex-row">
          <img src="../../../../assets/img/android-chrome-192x192.png" class="img-fluid" style="height: 3vw;" alt="">
          <h5 class="fw-bold mt-3" style="font-size: 1vw !important">
            PESTEL-INTRO
          </h5>
        </div>
        <img class="rounded" src="/img/pestel.jpg" style="width: 40vw" alt="">

        <hr class="mt-3">
        <button  class="btn mt-3 btn-primary btn-submit-1" @click.prevent="complete">متوجه شدم</button>
      </div>
    </center>
    <div v-else style="    position: absolute;
      right: 28vw;
      width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0 p-5" style="    margin: 1vw .9vw;">
        <h3>
          ارزیابی عوامل داخلی
        </h3>
        <hr class="mb-3">
        <div class="d-flex flex-column">
          

          <div class="d-flex mt-2">
            <div class="card col-6 p-3 d-flex flex-column align-items-center justify-content-center ">
              <h3> ماتریس IFE </h3>
              <router-link to="/Evaluation_of_internal_factors_matrices_efe" class="btn btn-submit-1 btn-primary"
                           style="width: 10vw !important;">تکمیل اطلاعات/بروزرسانی
              </router-link>
            </div>


            <div class="card col-6 p-3 d-flex flex-column align-items-center justify-content-center mx-1">
              <h3>
                ماتریس جذابیت
              </h3>
              <router-link to="/Evaluation_of_internal_factors_matrices_attractiveness" class="btn btn-submit-1 btn-primary"
                           style="width: 10vw !important;">تکمیل اطلاعات/بروزرسانی
              </router-link>
            </div>
          </div>

          <hr class="mt-2">


        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import router from "@/router";

export default {
  name: 'HomeView',
  components: {
    Sidebar,
    splash
  },
  data() {
    return {
      first_check: false,
      second_check: false,
      third_check: false,
      fourth_check: false,
      status: true,
    }
  },
  methods: {
    complete() {
      this.status = false;
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    checkIsMother() {
      if (this.is_mother) {
        router.push('/mother_items')
        return
      }

    },
    all() {
      fetch(`${this.base_url}/VisionQuestion/check`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({}),
      })
          .then(response => response.json())
          .then((response) => {
            if (response.first_check) {
              this.first_check = response.first_check
              this.second_check = response.second_check
              this.third_check = response.all_hamel_questionnaire_true
              this.fourth_check = response.all_team_vision_true
            }


          }).catch((err) => {
      })
    },
  },
  mounted() {
    this.checkIsMother()
    this.all()
  }
}
</script>
<style scoped lang="scss">
a {
  font-size: 1vw;
}

/*.line_after{
  position: relative;
  &::after{
    position: absolute;
    width: 0.01vw;
    height: 53vw;
    content: '';
    background-color: #efecf3 !important;
    top: 5vw;
    right: 35.3vw ;
    border-radius: 1vw;
  }
}*/

h3 {
  font-size: 1.3vw !important;
}

small, span {
  font-size: 1vw !important;
}
</style>